export const SearchEngineIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.00065 13.6468C8.70832 14.2802 9.64285 14.6654 10.6673 14.6654C12.8765 14.6654 14.6673 12.8745 14.6673 10.6654C14.6673 8.82076 13.4187 7.26776 11.7205 6.8055M4.28077 6.8055C2.5826 7.26776 1.33398 8.82076 1.33398 10.6654C1.33398 12.8745 3.12484 14.6654 5.33398 14.6654C7.54312 14.6654 9.33398 12.8745 9.33398 10.6654C9.33398 10.145 9.23465 9.6479 9.05385 9.1919M12.0007 5.33203C12.0007 7.54116 10.2098 9.33203 8.00065 9.33203C5.79151 9.33203 4.00065 7.54116 4.00065 5.33203C4.00065 3.12289 5.79151 1.33203 8.00065 1.33203C10.2098 1.33203 12.0007 3.12289 12.0007 5.33203Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
